// extracted by mini-css-extract-plugin
module.exports = {"passwordRules":"UpdatePassword-module__passwordRules--3bcBD"};